import { combineReducers } from 'redux-immutable';

import app from './app';
import user from './user';
import photos from './photos';
import books from './books';
import designs from './designs';
import orders from './orders';
import stats from './stats';
import giftcards from './giftcards';

export default combineReducers({
  app,
  user,
  photos,
  books,
  designs,
  orders,
  stats,
  giftcards,
});



// WEBPACK FOOTER //
// ./app/redux/reducers/index.js